import React from 'react';
import './Spinner.css';

interface PROPS {
  height?: number | string;
  width?: number | string;
  color?: string;
}

const Spinner = ({ height, width, color }: PROPS): JSX.Element => {
  return (
    <div style={{ height: height, width: width, display: 'flex', alignItems: 'center' }}>
      <div className="loader">
        <span style={{ background: color }}></span>

        <span style={{ background: 'white' }}></span>
      </div>
    </div>
  );
};

export default Spinner;
